import application from 'application/application';
import controller from './pdf-svg.controller';

import template from './pdf-svg.template.html';

application.directive('appPdfSvg', [
	function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				size: '@?'
			},
			controller: controller,
			templateUrl: template
		};
	}
]);
